export default "/images/2c2818ac9920d3c287ffe72361393b56.jpg";